<template>
  <div class="Herbal-medicine-detail">
    <!-- 公共头部 -->
    <!-- <vHeader></vHeader> -->
    <!-- 下半部分div -->
    <div class="contain">
      <el-row class="shareContent">
        <el-col :span="9">
          <el-carousel :interval="5000" arrow="always">
            <img
              src="../assets/img/gf.png"
              style="width:100%;height:99%"
            />
            <!--            <el-carousel-item v-for="(items, indexs) in drugPhotoUrl" :key="indexs">-->
            <!--              <img-->
            <!--                src="../assets/img/gf.png"-->
            <!--                style="width:100%;height:100%"-->
            <!--                v-if="indexs == '0'"-->
            <!--              />-->
            <!--            </el-carousel-item>-->
          </el-carousel>
        </el-col>
        <el-col :span="15" class="jieshao">
          <div style="display: flex; justify-content: space-between">
            <div>
              <!--              <div class="pinyin">{{ rectificationName }}</div>-->
              <div class="word">{{ rectificationName }}</div>
              <!--              <div class="bieming">【别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名】 {{ drugAlias }}</div>-->
            </div>
            <div>
              <!--              <div class="last-div">-->
              <!--                <el-button-->
              <!--                  size="mini"-->
              <!--                  icon="el-icon-share"-->
              <!--                  class="shareJ"-->
              <!--                  @click="shareF()"-->
              <!--                >分享</el-button-->
              <!--                >-->
              <!--                <div>-->
              <!--                  <share-->
              <!--                    :config="config1"-->
              <!--                    style="display:inline-block"-->
              <!--                    v-if="isShare"-->
              <!--                  ></share>-->
              <!--                </div>-->
              <!--                <div class="browse-count">浏览量：{{ atLlcs }}</div>-->
              <!--              </div>-->
            </div>
          </div>
          <el-divider></el-divider>
          <div>
            <el-row>
              <el-col :span="12">
                <div class="yaoxing">【编码章节】{{ section }}</div>
                <div class="yaoxing">【编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号】{{ gfId }}</div>
                <div class="yaoxing">【古方年代】{{ years }}</div>
              </el-col>
              <el-col :span="12">
                <div class="yaoxing">【古方追溯】{{ source }}</div>
                <div class="yaoxing">【作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者】{{ author }}</div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 下半部分 -->
      <el-row class="bottom-row" :gutter="20">
        <el-col :span="24" style="padding-left: 30px">
          <div class="title"><p class="iden"></p>古籍原文</div>
          <div class="content" v-html="originalText"></div>
          <div class="title"><p class="iden"></p>主要成分</div>
          <div style="display: flex;flex-wrap: wrap">
            <table class="table" style="margin: 10px 0">
              <thead>
              <tr style="min-height: 15px">
                <th style="height: 30px">中草药名称</th>
                <th style="height: 30px">剂量</th>
                <th style="height: 30px">制法</th>
              </tr>
              </thead>
              <tr v-for="(itemG, indexG) in tableData" :key="itemG.id">
                <td style="width: 20%">{{ itemG.medicineName }}</td>
                <td style="width: 20%">{{ itemG.dosage }}{{ itemG.unit }}</td>
                <td style="width: 60%">{{ itemG.zyzf }}</td>
              </tr>
            </table>
          </div>
          <div class="title"><p class="iden"></p>功效主治</div>
          <div class="content">{{ zhuzhi }}</div>
          <div class="title"><p class="iden"></p>处方制法</div>
          <div class="content">{{ method }}</div>
          <div class="title"><p class="iden"></p>煎服法</div>
          <div class="content">{{ yf }}</div>
          <div class="title"><p class="iden"></p>注意事项</div>
          <div class="content">{{ attention }}</div>

          <!--          <div class="title"><p class="iden"></p>功效</div>-->
          <!--          <div class="content">{{ effect }}</div>-->
          <!--          <div class="title"><p class="iden"></p>煎服法</div>-->
          <!--          <div class="content">{{ method }}</div>-->
          <!--          <div class="title"><p class="iden"></p>临床应用</div>-->
          <!--          <div class="content">{{ clinicApplication }}</div>-->

          <!--          <div class="title"><p class="iden"></p>方歌</div>-->
          <!--          <div class="content">{{ fangGe }}</div>-->
          <!--          <div class="title"><p class="iden"></p>处方制法</div>-->
          <!--          <div class="content">{{ methods }}</div>-->

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "ancPreDetail",
  data() {
    return {
      id: "",
      drugPhotoUrl: [],
      rectificationName: "",
      atName: "",
      drugAlias: "",
      gfId: "",
      source: "",
      section: "",
      years: "",
      author: "",
      atLlcs: "",
      method: "",
      zhuzhi: "",
      yf: '',
      method: "",
      clinicApplication: "",
      attention: "",
      fangGe: "",
      methods: "",
      originalText: "",
      tableData: []
    };
  },
  methods: {
    getDetail(id) {
      let that = this;
      let url = "/ancientPrescription/getAncientPrescriptionV2";
      let parmas = {
        id: id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.tableData = arr.ancientPrescriptionSlaves?arr.ancientPrescriptionSlaves:[];
            let ancientPrescriptionCy = arr.ancientPrescriptionCy ? arr.ancientPrescriptionCy : [];
						if (ancientPrescriptionCy.length) {
							ancientPrescriptionCy.forEach(item => {
								item.medicineName = item.ypName;
							});
							that.tableData = that.tableData.concat(
								ancientPrescriptionCy);
						}
            that.rectificationName = arr.rectificationName;
            that.atName = arr.atName;
            that.drugAlias = arr.drugAlias;
            that.gfId = arr.id;
            that.section = arr.section;
            that.source = arr.source;
            that.years = arr.years;
            that.author = arr.author;
            that.methods = arr.methods;
            that.atLlcs = arr.atLlcs;
            that.method = arr.method;
            that.zhuzhi = arr.zhuzhi;
            that.yf = arr.yf;
            that.method = arr.method;
            that.clinicApplication = arr.clinicApplication;
            that.attention = arr.attention;
            that.fangGe = arr.fangGe;
            that.originalText = arr.originalText;
          }
        })
    }
  },
  created() {
    let that = this;
    that.getDetail(that.$route.query.id);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Herbal-medicine-detail {
  /*padding-top: 44px;*/
}

.Herbal-medicine-detail .el-carousel__container .outer-img {
  width: 400px;
  height: 400px !important;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.adv-wrap {
  padding-top: 30px;
}

.shareContent {
  padding: 40px;
  background-color: #f9f9f9;
}

.adv-div {
  /* width: 310px;
    height: 190px; */
  /* background-color: #d3d3d3; */
  /* margin-top: 20px; */
  cursor: pointer;
  margin-top: 20px;
}

.iden {
  width: 3px;
  height: 19px;
  margin-right: 7px;
  background-color: #f64420;
}

.bottom-row {
  margin-top: 30px;
}

.bottom-row .title {
  font-size: 16px;
  display: flex;
  line-height: 24px;
  /*color: #f64420;*/
}

.bottom-row .content {
  font-size: 16px;
  margin-left: 10px;
  line-height: 36px;
  color: #666666;
  margin-bottom: 20px;
}

.jieshao {
  /*height: 300px;*/
}

.last-div {
  padding-top: 20px;
}

.browse-count {
  margin-top: 10px;
  font-size: 14px;
  color: #999999;
}

.shareJ {
  background-color: #f64420;
  color: white;
  text-align: center;
  font-size: 18px;
}

.yaoxing {
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}

/deep/ .el-divider {
  margin: 10px 0 20px 0;
}

.Box {
  border-radius: 3px;
}

.bieming {
  font-size: 14px;
  line-height: 24px;
  color: #666666;
  padding: 10px 0;
}

.word {
  font-size: 26px;
  color: #f64420;
}

.jieshao {
  padding: 40px;
  background-color: #f9f9f9;
}

.pinyin {
  font-size: 16px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/ancPreDetail.vue